export const UPDATE_FORM = 'UPDATE_FORM';

export const initialState = {
  checkinWidgetForm: {},
  mytripWidgetForm: {},
  flightStatusWidgetForm: {},
  bookWidgetForm: {}
};
